<h2 mat-dialog-title>{{data.apiKey.name ? data.apiKey.name : 'ITEM.API_KEY' | translate }}</h2>
<mat-dialog-content>
    <div class="row gy-2 gx-3">
        <div class="col-md-12">
            <p [innerHTML]="'MESSAGES.API_KEY_CREATED_MESSAGE' | translate"></p>
        </div>


        <div class="col-md-12 p-t-10">
            <mat-form-field appearance="outline" class="w-100" color="primary">
                <mat-label>{{ 'ITEM.API_KEY' | translate }} </mat-label>
                <input type="text" matInput fullWidth readonly [(ngModel)]="akiKey" tabindex="-1" />
                <a matSuffix (click)="copyToClipboard()" [matTooltip]="'TOOLTIP.COPY' | translate"
                    style="cursor: pointer;"> <mat-icon style="color: black;" inline>content_copy</mat-icon> </a>
            </mat-form-field>
        </div>

        <div class=" col-md-12 mb-3 p-3"
            *ngIf="data.apiKey.restriction == 'none' || data.apiKey.restrictions == null || data.apiKey.restrictions.length == 0">
            <p>
                <mat-icon inline class="warning">warning</mat-icon>
                <span [innerHTML]="'MESSAGES.NO_RESTRICTION' | translate"></span>
                <span
                    [innerHTML]="'MESSAGES.NO_RESTRICTION_EDIT' | translate: { apikeyEditLink: apikeyEditLink }"></span>

            </p>
        </div>

    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button color="primary" [mat-dialog-close]="true">{{ 'BUTTON.CLOSE' | translate }} </button>
</mat-dialog-actions>